import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import CinemapCarousel from '../carousel/carousel.component';
import { requestSoonMovies, requestRecentMovies } from '../../actions/movies.actions';

class RecentSoonMovies extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.requestSoonMovies();
        this.props.requestRecentMovies();
    };

    render() {
        return (
            <div className="recentSoonMovies">
                <div>
                    <Tabs>
                        <TabList>
                            <Tab>ACUM ÎN CINEMA</Tab>
                            <Tab>FILME ÎN CURÂND</Tab>
                        </TabList>

                        <TabPanel>
                            <CinemapCarousel cards={this.props.recentMovies} defaultSlidesToShow={6} component={"recentMovies"} />
                        </TabPanel>
                        <TabPanel>
                            <CinemapCarousel cards={this.props.soonMovies} defaultSlidesToShow={6} component={"soonMovies"}/>
                        </TabPanel>
                    </Tabs>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    soonMovies: state.movies.soonMovies,
    recentMovies: state.movies.recentMovies
});
export default connect(mapStateToProps, {requestSoonMovies, requestRecentMovies})(RecentSoonMovies);



// WEBPACK FOOTER //
// ./src/SHARED/components/recentsoonmovies/recentsoonmovies.component.js